/* SOLSTICE — facets.js : filtres + tri AJAX (Section Rendering API) */
(function () {
  'use strict';
  const root = document.querySelector('[data-collection-root]');
  if (!root) return;
  const sectionEl = root.closest('.shopify-section');
  const sectionId = sectionEl ? sectionEl.id.replace('shopify-section-', '') : null;
  if (!sectionId) return;

  let debounce;

  /* Open mobile facets drawer */
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-open-facets]')) {
      const d = document.querySelector('facets-sidebar');
      if (d && d.open) d.open();
      else if (d) d.classList.add('is-open');
    }
  });
  /* facets-sidebar extends drawer-element behavior */
  class FacetsSidebar extends (customElements.get('drawer-element') || HTMLElement) {}
  if (!customElements.get('facets-sidebar')) customElements.define('facets-sidebar', FacetsSidebar);

  /* Build URL from form + sort */
  function buildUrl() {
    const params = new URLSearchParams();
    const form = root.querySelector('[data-facets-form]');
    if (form) {
      new FormData(form).forEach((value, key) => {
        if (value !== '') params.append(key, value);
      });
    }
    const sort = root.querySelector('[data-sort-by]');
    if (sort && sort.value) params.set('sort_by', sort.value);
    return `${window.location.pathname}?${params.toString()}`;
  }

  async function applyFilters(url) {
    const wrap = root.querySelector('[data-grid-wrap]');
    if (wrap) wrap.classList.add('is-loading');
    try {
      const u = new URL(url, window.location.origin);
      u.searchParams.set('section_id', sectionId);
      const res = await fetch(u);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      ['[data-grid-wrap]', '[data-active-facets]', '[data-product-count]', '[data-facets-container]'].forEach((sel) => {
        const fresh = doc.querySelector(sel);
        const old = root.querySelector(sel);
        if (fresh && old) old.innerHTML = fresh.innerHTML;
      });

      window.history.pushState({}, '', url);
      document.dispatchEvent(new CustomEvent('collection:updated'));
    } catch (e) { console.error(e); }
    const wrap2 = root.querySelector('[data-grid-wrap]');
    if (wrap2) wrap2.classList.remove('is-loading');
  }

  /* Filter change (delegated — facets get re-rendered) */
  root.addEventListener('change', (e) => {
    if (e.target.closest('[data-facets-form]')) {
      clearTimeout(debounce);
      debounce = setTimeout(() => applyFilters(buildUrl()), e.target.type === 'number' ? 600 : 80);
    }
    if (e.target.closest('[data-sort-by]')) {
      applyFilters(buildUrl());
    }
  });

  /* Remove pill / clear all */
  root.addEventListener('click', (e) => {
    const pill = e.target.closest('[data-facet-remove]');
    if (pill) {
      e.preventDefault();
      applyFilters(pill.getAttribute('href'));
    }
  });

  /* Back/forward */
  window.addEventListener('popstate', () => applyFilters(window.location.href));
})();
